import { siteRoutes } from "@/routes/siteRoutes";
import { Box, Button, Container, Flex, Heading, Text } from "@radix-ui/themes";
import { FC, JSX } from "react";
import { useNavigate } from "react-router-dom";

const PageNotFound: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <>
      <Container px={{ initial: "4", lg: "0" }}>
        <Flex direction="column" gap="3">
          <Flex direction="column" gap="1">
            <Heading as="h1" mb="0">
              Page not found
            </Heading>
            <Text>The page you are looking for does not exist.</Text>
          </Flex>
          <Box>
            <Button onClick={() => navigate(siteRoutes.home.path)}>
              Go to {siteRoutes.home.label}
            </Button>
          </Box>
        </Flex>
      </Container>
    </>
  );
};

export default PageNotFound;
